import { Check, Clock } from "lucide-react";

export const ALL_STATUSES = [
  "Claim Registered",
  "Documents Verified",
  "Survey Assigned",
  "Survey Completed",
  "Approval Pending",
  "Approval Received",
  "Repair Started",
  "Repair Completed",
  "Settlement Processed",
  "Claim Closed",
];

export default function ClaimTimeline({ timeline = [], currentStatus }) {
  const reachedIndex = ALL_STATUSES.indexOf(currentStatus);

  const timelineMap = new Map();
  timeline.forEach((t) => { if (!timelineMap.has(t.status)) timelineMap.set(t.status, t); });

  return (
    <div className="space-y-0" data-testid="claim-timeline">
      {ALL_STATUSES.map((status, idx) => {
        const done = idx <= reachedIndex;
        const active = idx === reachedIndex;
        const entry = timelineMap.get(status);
        return (
          <div key={status} className="relative pl-10 pb-6 timeline-step" data-testid={`timeline-${idx}`}>
            <div
              className={`absolute left-0 top-0 w-6 h-6 rounded-full flex items-center justify-center border-2 ${
                done
                  ? "bg-[#003DA5] border-[#003DA5] text-white"
                  : "bg-white border-slate-300 text-slate-400"
              } ${active ? "ring-4 ring-blue-100" : ""}`}
            >
              {done ? <Check className="w-3.5 h-3.5" /> : <Clock className="w-3 h-3" />}
            </div>
            <div className="flex flex-col">
              <div className={`text-sm font-bold ${done ? "text-slate-900" : "text-slate-500"}`}>
                {status}
              </div>
              {entry && (
                <div className="text-xs text-slate-500 mt-0.5">
                  {entry.note && <span className="block">{entry.note}</span>}
                  {entry.at && <span className="text-slate-400">{new Date(entry.at).toLocaleString()}</span>}
                </div>
              )}
              {!entry && active && (
                <div className="text-xs text-[#FF7A00] font-semibold mt-0.5">In progress</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
